import FormMediaFile from 'components/common/forms/FormMediaFile';
import FormCheckbox from 'components/common/forms/FormCheckbox';
import FormRadioBtn from 'components/common/forms/FormRadioBtn';
import styles from 'styles/pages/chart/OralMicrobialExaminationChart.module.scss';
import {
  MicrobialTypes,
  MicrobialTypes1Label,
  MicrobialTypes2Label,
  OralMicrobialExaminationChartFields,
} from 'constants/chart/oralMicrobialExaminationChart';
import { TAttachmentFiles } from 'types/chart/oralMicrobialExaminationChart';

type TProps = {
  category: string;
  formMediaFileRefs: React.MutableRefObject<
    Array<{ resetFile: () => void } | null>
  >;
  attachmentFiles: TAttachmentFiles;
  deleteFileIdList: number[];
  setDeleteFileIdList: React.Dispatch<React.SetStateAction<number[]>>;
  changeFile: (index: number, file: File[]) => void;
  isRegister: boolean;
  isReadOnly: boolean;
  activeTabIndex: number;
};

const OralMicrobialExaminationChart = ({
  category,
  formMediaFileRefs,
  attachmentFiles,
  deleteFileIdList,
  setDeleteFileIdList,
  changeFile,
  isRegister,
  isReadOnly,
  activeTabIndex,
}: TProps) => {
  return (
    <>
      <table className={styles.table}>
        <thead>
          <tr className={styles.thead_tr}>
            <th className={styles.th} colSpan={2}>
              1차
            </th>
            <th className={styles.th} colSpan={2}>
              2차
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.tbody_tr}>
            <th className={styles.th}>미생물 (사진 or 영상)</th>
            <th className={styles.th}>결과</th>
            <th className={styles.th}>미생물 (사진 or 영상)</th>
            <th className={styles.th}>결과</th>
          </tr>
          <tr className={styles.tbody_tr}>
            <td className={styles.td_image_wrapper} rowSpan={3}>
              <FormMediaFile
                ref={(el) => {
                  formMediaFileRefs.current[0] = el as {
                    resetFile: () => void;
                  } | null;
                }}
                files={attachmentFiles[0] ? [attachmentFiles[0]] : []}
                acceptVideo={true}
                inputId="microbialFile1"
                readOnly={
                  !isRegister ||
                  isReadOnly ||
                  (category !== 'practice' && activeTabIndex === 2)
                }
                onDelete={(index) =>
                  setDeleteFileIdList([...deleteFileIdList, index])
                }
                onChange={(files) => changeFile(0, files)}
              />
            </td>
            <td className={styles.td}>
              <p className="text_left fw700">종류</p>
              <div className={styles.radio}>
                <FormCheckbox
                  name={OralMicrobialExaminationChartFields.microbialTypes1}
                  text={MicrobialTypes1Label[MicrobialTypes.round1_type1]}
                  value={MicrobialTypes.round1_type1}
                  multiple={true}
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                  labelStyle={{ paddingLeft: 0 }}
                />
                <FormCheckbox
                  name={OralMicrobialExaminationChartFields.microbialTypes1}
                  text={MicrobialTypes1Label[MicrobialTypes.round1_type2]}
                  value={MicrobialTypes.round1_type2}
                  multiple={true}
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                  labelStyle={{ paddingLeft: 0 }}
                />
              </div>
              <div className="flex justify_between mt12">
                <FormCheckbox
                  name={OralMicrobialExaminationChartFields.microbialTypes1}
                  text={MicrobialTypes1Label[MicrobialTypes.round1_type3]}
                  value={MicrobialTypes.round1_type3}
                  multiple={true}
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                  labelStyle={{ paddingLeft: 0 }}
                />
                <FormCheckbox
                  name={OralMicrobialExaminationChartFields.microbialTypes1}
                  text={MicrobialTypes1Label[MicrobialTypes.round1_type4]}
                  value={MicrobialTypes.round1_type4}
                  multiple={true}
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                  labelStyle={{ paddingLeft: 0 }}
                />
              </div>
            </td>
            <td className={styles.td_image_wrapper} rowSpan={3}>
              <FormMediaFile
                ref={(el) => {
                  formMediaFileRefs.current[1] = el as {
                    resetFile: () => void;
                  } | null;
                }}
                files={attachmentFiles[1] ? [attachmentFiles[1]] : []}
                acceptVideo={true}
                inputId="microbialFile2"
                readOnly={
                  !isRegister ||
                  isReadOnly ||
                  (category !== 'practice' && activeTabIndex === 0)
                }
                onDelete={(index) =>
                  setDeleteFileIdList([...deleteFileIdList, index])
                }
                onChange={(files) => changeFile(1, files)}
              />
            </td>
            <td className={styles.td}>
              <p className="text_left fw700">종류</p>
              <div className={styles.radio}>
                <FormCheckbox
                  name={OralMicrobialExaminationChartFields.microbialTypes2}
                  text={MicrobialTypes2Label[MicrobialTypes.round2_type1]}
                  value={MicrobialTypes.round2_type1}
                  multiple={true}
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                  labelStyle={{ paddingLeft: 0 }}
                />
                <FormCheckbox
                  name={OralMicrobialExaminationChartFields.microbialTypes2}
                  text={MicrobialTypes2Label[MicrobialTypes.round2_type2]}
                  value={MicrobialTypes.round2_type2}
                  multiple={true}
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                  labelStyle={{ paddingLeft: 0 }}
                />
              </div>
              <div className="flex justify_between mt12">
                <FormCheckbox
                  name={OralMicrobialExaminationChartFields.microbialTypes2}
                  text={MicrobialTypes2Label[MicrobialTypes.round2_type3]}
                  value={MicrobialTypes.round2_type3}
                  multiple={true}
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                  labelStyle={{ paddingLeft: 0 }}
                />
                <FormCheckbox
                  name={OralMicrobialExaminationChartFields.microbialTypes2}
                  text={MicrobialTypes2Label[MicrobialTypes.round2_type4]}
                  value={MicrobialTypes.round2_type4}
                  multiple={true}
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                  labelStyle={{ paddingLeft: 0 }}
                />
              </div>
            </td>
          </tr>
          <tr className={styles.tbody_tr}>
            <td className={styles.td}>
              <p className="text_left fw700">양 (0~5)</p>
              <div className={styles.radio}>
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity1}
                  labelText="0"
                  value="0"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity1}
                  labelText="1"
                  value="1"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity1}
                  labelText="2"
                  value="2"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
              </div>
              <div className={styles.radio}>
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity1}
                  labelText="3"
                  value="3"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity1}
                  labelText="4"
                  value="4"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity1}
                  labelText="5"
                  value="5"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
              </div>
            </td>
            <td className={styles.td}>
              <p className="text_left fw700">양 (0~5)</p>
              <div className={styles.radio}>
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity2}
                  labelText="0"
                  value="0"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity2}
                  labelText="1"
                  value="1"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity2}
                  labelText="2"
                  value="2"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
              </div>
              <div className={styles.radio}>
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity2}
                  labelText="3"
                  value="3"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity2}
                  labelText="4"
                  value="4"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialQuantity2}
                  labelText="5"
                  value="5"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
              </div>
            </td>
          </tr>
          <tr className={styles.tbody_tr}>
            <td className={styles.td}>
              <p className="text_left fw700">활동성 (0~5)</p>
              <div className={styles.radio}>
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity1}
                  labelText="0"
                  value="0"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity1}
                  labelText="1"
                  value="1"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity1}
                  labelText="2"
                  value="2"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
              </div>
              <div className={styles.radio}>
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity1}
                  labelText="3"
                  value="3"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity1}
                  labelText="4"
                  value="4"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity1}
                  labelText="5"
                  value="5"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 2)
                  }
                />
              </div>
            </td>
            <td className={styles.td}>
              <p className="text_left fw700">활동성 (0~5)</p>
              <div className={styles.radio}>
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity2}
                  labelText="0"
                  value="0"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity2}
                  labelText="1"
                  value="1"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity2}
                  labelText="2"
                  value="2"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
              </div>
              <div className={styles.radio}>
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity2}
                  labelText="3"
                  value="3"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity2}
                  labelText="4"
                  value="4"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
                <FormRadioBtn
                  name={OralMicrobialExaminationChartFields.microbialActivity2}
                  labelText="5"
                  value="5"
                  readOnly={
                    !isRegister ||
                    isReadOnly ||
                    (category !== 'practice' && activeTabIndex === 0)
                  }
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default OralMicrobialExaminationChart;
